import React, { useState } from 'react';
import { PolygonItemType } from 'components/polygon-card/polygon-item';
import { DeleteIcon } from 'cokitchen-icons';
import PolygonModal, { PolygonModalType } from 'components/polygon-modal';

import PageHeaderText from 'components/base/page-header-text';
import { CoKitchenPolygons } from 'utils/types';
import { Button } from '@cokitchen/cokitchen-components';
import PolygonCard from 'components/polygon-card';
import { ReactComponent as NoPolygon } from 'assets/icons/no_polygon.svg';
import { LatLngTuple } from 'leaflet';
import { apiService } from 'services/base.service';
import useCokitchenContext from 'contexts/cokitchen.context';
import useDashboardContext from 'contexts/dashboard.context';
import { ROUTE_KEYS } from 'utils/constants';
import { useNavigate } from 'react-router-dom';
import { handleApiError } from 'utils/functions';
const CreateCokitchenPolygon = () => {
  const navigate = useNavigate();
  const { newCokitchen } = useCokitchenContext();
  const [loading, setLoading] = useState(false);
  const [showPolygonModal, setShowPolygonModal] = useState(false);
  const [type, setType] = useState<PolygonModalType>('create');
  const [activePolygon, setActivePolygon] = useState<CoKitchenPolygons | null>(null);
  const { cokitchenPolygons, setCokitchenPolygons, routePrefix } = useDashboardContext();

  const togglePolygonModal = () => {
    setShowPolygonModal(!showPolygonModal);
  };
  const addPolygon = () => {
    setType('create');
    togglePolygonModal();
  };

  const deletePolygon = () => {
    const filteredPolygons = cokitchenPolygons.filter(
      (polygon) => polygon?.name !== activePolygon?.name
    );
    setCokitchenPolygons([...filteredPolygons]);
  };

  const POLYGON_MENU: PolygonItemType[] = [
    {
      name: 'Delete Polygon',
      icon: <DeleteIcon className='text-red-5' />,
      onClick: deletePolygon,
      className: 'text-red-5'
    }
  ];

  const createPolygon = async (payload: any) => {
    return await apiService.post(`marketing/cokitchen-polygon`, { data: payload });
  };

  const createAllPolygon = async () => {
    if (!newCokitchen?.id) return;
    try {
      setLoading(true);
      await Promise.all(
        cokitchenPolygons.map(async (item) => {
          const payload = { cokitchen_id: newCokitchen?.id, ...item };
          await createPolygon(payload);
        })
      );
      navigate(
        `${routePrefix}/${ROUTE_KEYS.CREATE_COKITCHEN}/${ROUTE_KEYS.CREATE_COKITCHEN_EXPLORE}`
      );
      setCokitchenPolygons([]);
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <PageHeaderText
        title='Create Polygon'
        description='Create new delivery polygons to expand the reach of the kitchen'
      />
      <div className='w-full max-w-[681px] h-[55vh]'>
        <div className=' pt-4 mt-8'>
          {cokitchenPolygons?.length === 0 ? (
            <div className='flex flex-col pt-4 space-y-2 justify-center items-center '>
              <NoPolygon />
              <p className='text-sm text-gray-5 font-medium mb-2'>Yet to create any polygon</p>
            </div>
          ) : (
            <div className='w-[420px]'>
              <PolygonCard
                list={POLYGON_MENU}
                setActivePolygon={setActivePolygon}
                polygons={cokitchenPolygons}
                showAddButton={addPolygon}
              />
            </div>
          )}
          {cokitchenPolygons?.length === 0 && (
            <Button
              variant='block'
              color='primary'
              className='mt-8 w-[157px] mx-auto h-[40px] font-medium text-sm'
              onClick={addPolygon}>
              Add a polygon
            </Button>
          )}

          <PolygonModal
            show={showPolygonModal}
            onClose={() => {
              togglePolygonModal();
            }}
            positions={activePolygon?.polygon as LatLngTuple[]}
            data={{
              name: activePolygon?.name ?? '',
              delivery_fee: activePolygon?.delivery_fee ?? '',
              delivery_service_charge: activePolygon?.delivery_service_charge ?? '',
              cokitchen_polygon_id: activePolygon?.id ?? '',
              delivery: activePolygon?.delivery ?? false,
              pickup: activePolygon?.pickup ?? false
            }}
            type={type}
          />
        </div>
      </div>
      {cokitchenPolygons?.length > 0 && (
        <Button
          variant='block'
          color='primary'
          onClick={createAllPolygon}
          disabled={!newCokitchen?.id || !cokitchenPolygons.length}
          loading={loading}
          className='mt-8 ml-auto w-[157px] h-[40px] font-medium text-sm'>
          Continue
        </Button>
      )}
    </div>
  );
};

export default CreateCokitchenPolygon;
